import React from 'react';
import { Button } from '@mui/material';
import { terminalOrangeButtonSx } from '../../theme/terminalStyles';

const TerminalOrangeButton = ({ sx, children, ...props }) => (
  <Button variant="contained" disableElevation sx={{ ...terminalOrangeButtonSx, ...sx }} {...props}>
    {children}
  </Button>
);

export default TerminalOrangeButton;
